import { useRef } from 'react';
import { Divider } from '@cencosud-cencommerce/paris-uikit';

import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks';
import useEscapeKeyHandler from '@/modules/perseo-billing/hooks/use-escape-key-handler';
import {
  CardHeader,
  Icon,
  Typography,
  useMediaQuery
} from '@/modules/perseo-billing/ui/react/src';

interface ICencoPayModalHeader {
  closeModal: () => void;
  isModalQRCencopayVisible: boolean;
}

export const CencoPayModalHeader = (props: ICencoPayModalHeader) => {
  const isMobile = useMediaQuery('sm');
  if (isMobile) return null;

  return (
    <>
      <CardHeader
        pb={16}
        action={<ButonClose {...props} />}
        title={<Title />}
      />
      <Divider />
    </>
  );
};

const ButonClose = (props: ICencoPayModalHeader) => {
  const { closeModal, isModalQRCencopayVisible } = props;

  const buttonCloseRef = useRef<HTMLButtonElement>(null);
  useEscapeKeyHandler(isModalQRCencopayVisible, buttonCloseRef);
  const { cencoPayCloseModalGtm } = useGtmBillingProduct();

  return (
    <button
      ref={buttonCloseRef}
      className="co-cursor-pointer"
      onClick={() => {
        cencoPayCloseModalGtm();
        closeModal();
      }}
    >
      <Icon icon="CloseIcon" width={16} height={16} />
    </button>
  );
};

const Title = () => (
  <div className="co-flex co-gap-[12px] co-items-center">
    <Icon icon="CellPhoneWithBtn" width={18} height={18} />

    <Typography className="co-font-[18px]" size="h3" weight="semibold">
      Pagar con CencoPay
    </Typography>
  </div>
);
